import { adminApiRequest } from "../../utils/apiUtils";

export interface IGameBan {
  id: number;
  nickname: string;
  phoneNumber: string;
  userName: string;
  textId: string;
  memo?: string;
  createdAt: string;
}

export const GameBanAPI = {
  getGameBanList: () => adminApiRequest.get(`/game-ban`),
  deleteGameBan: (id: number) => adminApiRequest.delete(`/game-ban/${id}`),
  registerGameBan: (body: any) => adminApiRequest.post(`/game-ban/ban`, body),
};
